import { http_client } from "@/plugins/http_client";

const url = "/api/v1/catalogos/departamento";
const getDepartamentos = async (params = {}) =>
  await http_client(url, params, "get");

export default {
  getDepartamentos,
};
